export default function BrandLogo({
  iconSize = 44,
  textSize = 28,
  textColor = "#8FA288",
}) {
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
      <img
        src="/zaya-life-logo-transparent.png"
        alt="Zaya Life logo"
        width={iconSize}
        height={iconSize}
        style={{
          width: iconSize,
          height: iconSize,
          objectFit: "contain",
          flexShrink: 0,
          mixBlendMode: "screen",
        }}
      />
      <span
        style={{
          color: textColor,
          fontSize: textSize,
          lineHeight: 1,
          fontWeight: 500,
          letterSpacing: "0.06em",
          fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
          whiteSpace: "nowrap",
          textTransform: "uppercase",
          transform: "translateY(1px)",
        }}
      >
      </span>
    </div>
  );
}
